import { type FC } from "react";
import { models } from "types/api/viewModels.ts";
import { convertToTitleCase } from "utils/string.ts";
import { Chip } from "components/Chip";
import { ItemOnBackorderText } from "constants/text.ts";
import {
	BackorderedGroup,
	CardInfoWrapper
} from "components/OrderDetailsLineItem/components/CardInfo/cardInfo.styles.ts";

interface CardInfoProps {
	quantityBackordered: number | null | undefined;
	status: models["OrderStatus"] | null | undefined;
}

const CardInfo: FC<CardInfoProps> = ({ quantityBackordered, status }) => {
	if (!quantityBackordered && !status) return null;

	return (
		<CardInfoWrapper>
			<Chip
				label={convertToTitleCase(status)}
				visible={Boolean(status)}
			/>
			{Boolean(quantityBackordered) && (
				<BackorderedGroup>
					<div aria-description="Order Details Backorder Logo">
						<img
							src="/assets/BackorderIcon.svg"
							alt="backorder logo"
						/>
					</div>
					<div>
						{ItemOnBackorderText} ({quantityBackordered})
					</div>
				</BackorderedGroup>
			)}
		</CardInfoWrapper>
	);
};

export default CardInfo;
